module.exports = __webpack_public_path__ + "img/storage-tank.67f58d7a.png";